var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"title"},[_vm._v("逆流云挂机")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }